export default __webpack_public_path__ + "static/media/greyWarning.d099c944.svg";